import { Preloader } from 'mmfintech-portal-commons'

export const CustomPreloader = () => <Preloader color='#131e3d' />